import { useState, useContext } from "react";
import axios from "axios";
import "../css/SetNewPin.css";
import "../css/mainhome.css";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import kkko from "../assets/icons/logo.png";

export default function SetNewPinScreen() {
  const { mobileNo, setUser } = useContext(AppContext);
  const [enteredPassword, setEnteredPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!enteredPassword) {
      toast.warn("Please enter your password.");
      return;
    }

    setIsLoading(true);

    try {
      const res = await axios.post(
        "https://admin.thedpboss.com/api/v1/reset-mpin",
        {
          mobileNo,
          password: enteredPassword,
          security_pin: 1234,
        }
      );

      if (res.data.status === true) {
        const { registerId, accessToken } = res.data.info;

        localStorage.removeItem("accessToken");
        localStorage.removeItem("registerId");

        localStorage.setItem("registerId", registerId);
        localStorage.setItem("accessToken", accessToken);

        const profileRes = await axios.post(
          "https://admin.thedpboss.com/api/v1/user-details-by-register-id",
          { registerId },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              Accept: "application/json",
            },
          }
        );

        if (profileRes.data.status && profileRes.data.info) {
          const userInfo = profileRes.data.info;

          localStorage.setItem(
            "userProfile",
            JSON.stringify(userInfo)
          );
          localStorage.setItem(
            "walletBalance",
            userInfo.walletBalance
          );

          if (setUser) setUser(userInfo);

          toast.success("Login successful!");
          navigate("/home", { replace: true });
        } else {
          toast.warn(
            "Login successful, but failed to load profile."
          );
          navigate("/home", { replace: true });
        }
      } else {
        toast.error(
          res.data.msg || "Login failed. Please try again."
        );
      }
    } catch (err) {
      console.error("Login error:", err?.response || err);
      toast.error("Something went wrong. Try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="top-header">Login</div>

      <div className="setpin-content-wrapper">
        <div className="logo-image-wrapper">
          <img src={kkko} alt="Logo" className="sararr" />
        </div>

        <div className="password-group">
          <input
            type="password"
            className="text-input"
            value={enteredPassword}
            placeholder="Enter Password"
            onChange={(e) =>
              setEnteredPassword(e.target.value)
            }
          />
        </div>

        <button
          className="setpin-btn"
          onClick={handleLogin}
          disabled={isLoading}
        >
          {isLoading ? "LOGGING IN..." : "LOGIN"}
        </button>
      </div>
    </div>
  );
}